import React from 'react';

const performanceChartIcon = (width,height,color) =>
    <svg width={width ? width:'25'} height={height ? height:'25'} viewBox='0 0 25 25' fill={color ? color:'#fff'} xmlns='http://www.w3.org/2000/svg'>
        <path d='M17.6545 5.62726H24.5273V12.5H22.8091V8.56696L15.0773 16.2854L11.6409 12.849L2.1909 22.3124V22.8091H24.5273V24.5273H0.472717V0.472717H2.1909V19.8694L11.6409 10.4328L15.0773 13.8692L21.5876 7.34544H17.6545V5.62726Z' title='Graphiques des prix' />
    </svg>;

export default performanceChartIcon;
